module.exports = __webpack_public_path__ + "img/crm-png.bfeec02e.png";